import {
    GET_MINI_CART_COUNT_ACTION_BEGIN,
    GET_MINI_CART_COUNT_ACTION_SUCCESS,
    GET_MINI_CART_COUNT_ACTION_FAIL,
}from "../middleware/types"

const initialState = {
    ACTION_loading: false,
    error: {},
    response : {}
  }

  export default (state = initialState, action) => {
    switch (action.type) {
      case GET_MINI_CART_COUNT_ACTION_BEGIN:
        return {
          ...state,
          ACTION_loading: true
        }
      case GET_MINI_CART_COUNT_ACTION_SUCCESS:
          return {
              ...state,
              ACTION_loading: false,
              response: {
                ...action.payload
              }
          }
      case GET_MINI_CART_COUNT_ACTION_FAIL:
        return {
          ...state,
          ACTION_loading: false,
          error: action.payload
        }
      default:
        return state
    }
  }